import {
  AccountApi,
  AchievementApi,
  Configuration,
  ConnectApi,
  ContentsApi,
  PaymentApi,
  PaymentStripeApi,
  ProductApi,
  SiteApi,
  TagApi,
  UserActionApi,
  UserApi,
  ViewerApi,
} from "../api";
import { logInfo, logWarn } from "@lib/logger";

const createClient = () => {
  const config: Configuration = new Configuration({
    basePath: process.env.NEXT_PUBLIC_API_ENDPOINT,
    headers: { Authorization: `Bearer ${process.env.API_KEY}` },
    credentials: "include",

    // fetchをラップしてAPIのレスポンス時間をロギングする
    fetchApi: async (input: RequestInfo | URL | string, init) => {
      const startTime = Date.now();
      const response = await fetch(input, init);
      const durationMs = Date.now() - startTime;
      //inputの型は Request | string | URL
      const url = typeof input === "string" ? input : input instanceof URL ? input.href : input.url;
      const data = {
        url,
        durationMs,
      };
      if (durationMs > 500) {
        logWarn("API request took too long", {
          data,
          status: response.status,
        });
      } else {
        logInfo("API request", {
          data,
          status: response.status,
        });
      }
      return response;
    },
  });

  return {
    account: new AccountApi(config),
    achievement: new AchievementApi(config),
    contents: new ContentsApi(config),
    payment: new PaymentApi(config),
    paymentStripe: new PaymentStripeApi(config),
    product: new ProductApi(config),
    site: new SiteApi(config),
    tag: new TagApi(config),
    userAction: new UserActionApi(config),
    user: new UserApi(config),
    connect: new ConnectApi(config),
    viewer: new ViewerApi(config),
  };
};

export const comiciPlusClient = createClient();
